import { useState } from 'react';
import { Card, Form, Button, Row, Col, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; 
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import authService from '../services/authService';
import './Auth.css';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const userData = await authService.login({ username, password });
            const role = userData.role || '';

            if (role === 'ROLE_ADMIN' || role === 'ADMIN') {
                navigate('/admin/dashboard');
            } else {
                navigate('/dashboard');
            }
        } catch (err) {
            const errorMsg =
                err.response?.data?.message ||
                err.response?.data ||
                'Login gagal. Periksa username dan password Anda.';
            setError(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <Card className="auth-card">
                <Row className="g-0">
                    {/* Sisi Kiri: Branding */}
                    <Col md={5} className="auth-branding-section d-none d-md-flex">
                        <div>
                            <h2>SIPUMA</h2>
                            <p>Sistem Pengaduan Masyarakat<br/>Direktorat Jenderal Bea dan Cukai</p>
                        </div>
                    </Col>
                    
                    {/* Sisi Kanan: Form Login */}
                    <Col md={7} className="auth-form-section">
                        <div className="text-center mb-4 d-md-none">
                            <h3 className="fw-bold text-primary">SIPUMA</h3>
                            <p className="text-muted small">Sistem Pengaduan Masyarakat</p>
                        </div>
                        
                        <h4 className="fw-bold mb-4">Masuk ke Akun Petugas</h4>
                        
                        {error && <Alert variant="danger">{error}</Alert>}
                        
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-semibold small">Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Masukkan username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            
                            <Form.Group className="mb-4 position-relative">
                                <Form.Label className="fw-semibold small">Password</Form.Label>
                                <Form.Control
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Masukkan password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-muted text-decoration-none"
                                    style={{ marginTop: '12px', zIndex: 10 }}
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </Form.Group>
                            
                            <div className="d-grid mt-4">
                                <Button variant="primary" type="submit" disabled={loading} size="lg" className="rounded-pill">
                                    {loading ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            Memproses...
                                        </>
                                    ) : (
                                        'Masuk'
                                    )}
                                </Button>
                            </div>
                        </Form>
                        {/* Area Tautan Pendaftaran Telah Dihapus Sepenuhnya */}
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default LoginPage;